import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCheckout = location.pathname.startsWith('/checkout');

  const handleNavigation = (sectionId: string) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {isCheckout && (
              <Link 
                to="/" 
                className="flex items-center text-gray-600 hover:text-gray-900"
              >
                <ChevronLeft className="h-5 w-5 mr-1" />
                <span>Back</span>
              </Link>
            )}
            <Link to="/" className="flex items-center">
              <Logo />
            </Link>
          </div>
          {!isCheckout && (
            <nav className="hidden md:flex space-x-8">
              <button 
                onClick={() => handleNavigation('how-it-works')} 
                className="text-gray-600 hover:text-gray-900"
              >
                How It Works
              </button>
              <button 
                onClick={() => handleNavigation('assessments')} 
                className="text-gray-600 hover:text-gray-900"
              >
              
                Pricing
              </button>
              <Link to="/learn-more" className="text-gray-600 hover:text-gray-900">
                Learn More
              </Link>
              <Link to="/coming-soon" className="text-gray-600 hover:text-gray-900">
                Coming Soon
              </Link>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
}